function calculatorLifeInsurance() {
        "use strict";

        var root = document.querySelector(".cover-calculator");
        var totalDisplay = document.querySelector(".cover-total");

        function isCoverInput(el) {
          return el && el.classList && el.classList.contains("cover-calc-input");
        }

        function digitsOnly(str) {
          return String(str || "").replace(/\D/g, "");
        }

        function parseMoney(str) {
          var d = digitsOnly(str);
          if (d === "") return 0;
          var n = parseInt(d, 10);
          return isNaN(n) ? 0 : Math.min(n, 999999999999);
        }

        function formatCommas(n) {
          return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        function countDigitsToLeft(str, index) {
          var i;
          var c = 0;
          for (i = 0; i < index && i < str.length; i++) {
            if (/\d/.test(str[i])) c++;
          }
          return c;
        }

        function caretAfterDigitCount(formatted, digitCount) {
          if (digitCount <= 0) return 0;
          var seen = 0;
          var i;
          for (i = 0; i < formatted.length; i++) {
            if (/\d/.test(formatted[i])) {
              seen++;
              if (seen === digitCount) return i + 1;
            }
          }
          return formatted.length;
        }

        function syncInput(el) {
          var raw = el.value;
          var caret = el.selectionStart == null ? raw.length : el.selectionStart;
          var digitsLeft = countDigitsToLeft(raw, caret);
          var n = parseMoney(raw);
          var formatted = formatCommas(n);
          el.value = formatted;
          var newCaret = caretAfterDigitCount(formatted, digitsLeft);
          el.setSelectionRange(newCaret, newCaret);
          return n;
        }

        function wrapFor(inputEl) {
          return inputEl.closest(".input-wrap");
        }

        function updateWrapState(inputEl, value) {
          var wrap = wrapFor(inputEl);
          if (!wrap) return;
          if (value > 0) wrap.classList.add("has-value");
          else wrap.classList.remove("has-value");
        }

        function computeCoverTotal() {
          if (!root) return 0;
          var els = root.querySelectorAll(".cover-calc-input");
          var sum = 0;
          var i;
          for (i = 0; i < els.length; i++) {
            var el = els[i];
            var n = parseMoney(el.value);
            var sign = el.getAttribute("data-cover-sign");
            if (sign === "subtract") sum -= n;
            else sum += n;
          }
          return sum < 0 ? 0 : sum;
        }

        function renderTotal() {
          if (!totalDisplay) return;
          totalDisplay.textContent = "£" + formatCommas(computeCoverTotal());
        }

        function onMoneyInput(ev) {
          var el = ev.target;
          if (!isCoverInput(el)) return;
          var n = syncInput(el);
          updateWrapState(el, n);
          renderTotal();
        }

        function onBeforeInput(ev) {
          if (!isCoverInput(ev.target)) return;
          if (ev.inputType === "insertFromPaste") return;
          if (ev.data != null && ev.data !== "" && /\D/.test(ev.data)) {
            ev.preventDefault();
          }
        }

        function onKeydown(ev) {
          if (!isCoverInput(ev.target)) return;
          var allowed =
            ev.key === "Backspace" ||
            ev.key === "Delete" ||
            ev.key === "Tab" ||
            ev.key === "Escape" ||
            ev.key === "Enter" ||
            ev.key === "ArrowLeft" ||
            ev.key === "ArrowRight" ||
            ev.key === "ArrowUp" ||
            ev.key === "ArrowDown" ||
            ev.key === "Home" ||
            ev.key === "End" ||
            ev.ctrlKey ||
            ev.metaKey ||
            ev.altKey;
          if (allowed) return;
          if (/^\d$/.test(ev.key)) return;
          ev.preventDefault();
        }

        function onPaste(ev) {
          var el = ev.target;
          if (!isCoverInput(el)) return;
          ev.preventDefault();
          var paste = digitsOnly(
            (ev.clipboardData || window.clipboardData).getData("text")
          );
          var start = el.selectionStart;
          var end = el.selectionEnd;
          var val = el.value;
          var left = digitsOnly(val.slice(0, start));
          var right = digitsOnly(val.slice(end));
          var merged = left + paste + right;
          var n =
            merged === ""
              ? 0
              : Math.min(parseInt(merged, 10) || 0, 999999999999);
          var formatted = formatCommas(n);
          el.value = formatted;
          var newCaret = caretAfterDigitCount(
            formatted,
            left.length + paste.length
          );
          el.setSelectionRange(newCaret, newCaret);
          updateWrapState(el, n);
          renderTotal();
        }

        function init() {
          if (!root || !totalDisplay) return;
          root.addEventListener("beforeinput", onBeforeInput);
          root.addEventListener("keydown", onKeydown);
          root.addEventListener("input", onMoneyInput);
          root.addEventListener("paste", onPaste);
          var els = root.querySelectorAll(".cover-calc-input");
          var k;
          for (k = 0; k < els.length; k++) {
            var el = els[k];
            var n = parseMoney(el.value);
            el.value = formatCommas(n);
            updateWrapState(el, n);
          }
          renderTotal();
        }

        init();
      }

document.addEventListener('DOMContentLoaded', () => {
          
    calculatorLifeInsurance()

})